//#region Imports

import { NgModule } from '@angular/core';

import { NetworkService } from './services/network.service';

//#endregion

@NgModule({
  providers: [
    NetworkService,
  ],
})
export class NetworkModule { }
